import { Paper, Skeleton } from "@mui/material"
import DataRow from "./components/DataRow"
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Checkbox } from "@mui/material"
import MultiSelectFilter from "./components/filters/MultiSelectFilter"
import useSelection from "./hooks/useSelection"
import { MULTI_SELECT_KEYS } from "../constants"

const HEADER_CONFIG = [
    { key: "select", type: "checkbox" },
    { key: "stock_no", type: "text", label: "Stock No." },
    { key: "report_no", type: "text", label: "GIA Report" },
    { key: "ct", type: "text", label: "Carat" },
    ...MULTI_SELECT_KEYS.map(selector => ({ key: selector, type: "filter", selector })),
    { key: "disc", type: "text", label: "Discount" },
    { key: "total_dollar", type: "text", label: "$ Amount" },
]

const tableContainerSx = { gridColumn: '1', overflow: 'auto', mt: 1 }

function TableSkeleton() {
    return (
        <TableBody>
            {Array.from({ length: 10 }).map((_, index) => (
                <TableRow key={index}>
                    <TableCell colSpan={11} sx={{ py: 2 }}>
                        <Skeleton variant="rectangular" height={24} sx={{ borderRadius: 0.5 }} />
                    </TableCell>
                </TableRow>
            ))}
        </TableBody>
    )
}

function MainTable({ modifiers, filteredData, loading, isMobile }) {
    const { selections, setSelections } = modifiers
    const { 
        isAllSelected, 
        isSomeSelected, 
        handleSelectAll, 
        handleToggle,
        isSelected
    } = useSelection(filteredData, selections, setSelections)

    return (
        <TableContainer
            component={Paper}
            elevation={0}
            variant="outlined"
            sx={{
                ...tableContainerSx,
                mt: isMobile ? 0 : 1,
                border: isMobile ? 'none' : undefined,
                overflow: isMobile ? 'visible' : 'auto'
            }}
        >
            <Table stickyHeader size="medium">
                {!isMobile && (
                    <TableHead>
                        <TableRow sx={{ bgcolor: 'grey.50' }}>
                        {HEADER_CONFIG.map((column) => {
                            if (column.type === "checkbox") {
                                return (
                                    <TableCell padding="checkbox" key={column.key}>
                                        <Checkbox
                                            indeterminate={isSomeSelected}
                                            checked={isAllSelected}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                )
                            }

                            if (column.type === "filter") {
                                return (
                                    <TableCell sx={{ p: 0 }} align="center" key={column.key}>
                                        <MultiSelectFilter selector={column.selector} modifiers={modifiers} />
                                    </TableCell>
                                )
                            }

                            return (
                                <TableCell align="center" sx={{ py: 1 }} key={column.key}>
                                    {column.label}
                                </TableCell>
                            )
                        })}
                    </TableRow>
                </TableHead>
                )}
                {loading ? (
                    <TableSkeleton />
                ) : (
                    <TableBody>
                        {filteredData.map(dataItem => (
                            <DataRow 
                                dataItem={dataItem} 
                                key={dataItem.stock_no} 
                                selected={isSelected(dataItem.stock_no)}
                                onToggle={handleToggle}
                                isMobile={isMobile}
                            />
                        ))}
                    </TableBody>
                )}
            </Table>
        </TableContainer>
    )
}

export default MainTable
